import React from "react";
import { useNavigate } from "react-router";
import Alert from "react-bootstrap/Alert";
import { useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";

import UserConstantsHelper from "../../helpers/constants/user";

const UnverifiedPerformerModal = ({ show, handleClose }) => {
  const navigate = useNavigate();
  const profile = useSelector((state) => state.users.profile);

  const handleBecomePerformer = () => {
    navigate("/become-performer");
    handleClose();
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      className={`verify light`}
    >
      <Modal.Body className="mb-4">
        <h2 className="text-center mt-4 bold mb-4">Oops!</h2>
        <Alert variant="danger text-center">
          <Button
            variant="primary"
            className={`btn-sm red react ${
              UserConstantsHelper.isDocumentPending(profile.data)
                ? "yellow"
                : "red"
            }`}
            type="button"
            title='exclamation'
          >
            <i className="fas fa-2x fa-exclamation"></i>
          </Button>
          <p>
            This feature is only accessible to verified Performers, if you would
            like to access this feature and other verififed Performer features,
            please Become A Performer
          </p>
        </Alert>
      </Modal.Body>
      <div className="footer">
        <Button variant="default" onClick={handleClose}>
          Close
        </Button>
        {UserConstantsHelper.isDocumentPending(profile.data) ? (
          <Button
            variant="default"
            type="submit"
            onClick={handleClose}
          >
            Ok
          </Button>
        ) : (
          <Button
            variant="default"
            type="submit"
            onClick={handleBecomePerformer}
          >
            Become A Performer
          </Button>
        )}
      </div>
    </Modal>
  );
};

export default UnverifiedPerformerModal;
